import { render } from "./GrupoGente.vue?vue&type=template&id=adb600d6"
import script from "./GrupoGente.vue?vue&type=script&lang=js"
export * from "./GrupoGente.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__